import Translate from "components/common/Translate";
import { InputErrorType } from "types/form-types";

type InputErrorsPropsType = {
    errors: InputErrorType[]
}

const InputErrors = (props: InputErrorsPropsType) => {
    if(!props.errors || !props.errors.length) return <></>;

    return (
        <div className="error-message">
            <ul>
                {props.errors.map(c => {
                    return (
                        <li
                            key={c.name}
                            className="text-red-500 text-xs "
                        >
                            <Translate i18nKey={c.message} />
                        </li>
                    );
                })}
            </ul>
        </div>
    )
}

export default InputErrors;
